import React, { useState, useEffect } from 'react';
import {
  Container,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  TextField,
  Button,
  Typography,
  Paper,
  Card,
  CardContent,
  ToggleButton,
  IconButton,
  Grid,
  Modal,
  Backdrop,
  Fade,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  LinearProgress,
  Switch,
} from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import TranslateIcon from '@mui/icons-material/Translate';
import SmsIcon from '@mui/icons-material/Sms';
import BadgeIcon from '@mui/icons-material/Badge';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LoginIcon from '@mui/icons-material/Login';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import { tr } from '../locales/tr';
import { en } from '../locales/en';
import { useRef } from 'react';


const verificationMethods = [
  { key: 'sms', icon: <SmsIcon /> },
  { key: 'tc', icon: <BadgeIcon /> },
  // { key: 'whatsapp', icon: <WhatsAppIcon /> },
  { key: 'login', icon: <LoginIcon /> },
];

const socialLinks = {
  instagram: 'https://instagram.com/yourpage',
  facebook: 'https://facebook.com/yourpage',
  twitter: 'https://twitter.com/yourpage',
};

// Country code options (expand as needed)
const countryCodes = [
  { code: '+90', label: 'Turkiye (+90)' },
  { code: '+1', label: 'USA (+1)' },
  { code: '+44', label: 'UK (+44)' },
  { code: '+49', label: 'Germany (+49)' },
  { code: '+33', label: 'France (+33)' },
  { code: '+7', label: 'Russia (+7)' },
  { code: '+61', label: 'Australia (+61)' },
  { code: '+81', label: 'Japan (+81)' },
  // ...add more as needed
];

const HotspotRegister = () => {
  const iframeRef = useRef(null);
  const [method, setMethod] = useState('sms');
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    idNumber: '',
    birthYear: '',
    whatsapp: '',
    countryCode: '',
    pinCode: '',
    username: '',
  });
  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    phone: false,
    idNumber: false,
    birthYear: false,
    whatsapp: false,
    countryCode: false,
    pinCode: false,
    username: false,
  });
  const [language, setLanguage] = useState('tr');
  const [logoUrl, setLogoUrl] = useState('/assets/default-logo.png');
  const [showPinInput, setShowPinInput] = useState(false);
  const [verificationData, setVerificationData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [serverMessage, setServerMessage] = useState('');
  const [loginType, setLoginType] = useState('other'); // 'phone' or 'other'
  const [isPhoneLogin, setIsPhoneLogin] = useState(false);
  const [linkLoginOnly, setLinkLoginOnly] = useState('');
  const [linkOrig, setLinkOrig] = useState('');
  const [defaultDst, setDefaultDst] = useState('');
  
  const t = language === 'tr' ? tr : en;

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 400 },
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
  };

  const fetchLogoByLocation = async () => {
    try {
      const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://apiproxy.logispot.net';
      const secureApiBaseUrl = apiBaseUrl.replace(/^http:/, 'https:');
      const logoApiEndpoint = '/api/get-logo-for-ip';
      
      const fullApiUrl = `${secureApiBaseUrl}${logoApiEndpoint}`;

      const response = await fetch(fullApiUrl); 
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.logoPath) {
        setLogoUrl(data.logoPath);
      } else {
        console.warn('No logoPath found in response, using default.');
        setLogoUrl('/assets/default-logo.png');
      }
    } catch (error) {
      console.error("Could not fetch logo configuration:", error);
      setLogoUrl('/assets/default-logo.png');
    }
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setLinkLoginOnly(params.get('link-login-only') || '');
    setLinkOrig(      params.get('link-orig')            || '');
    setDefaultDst(    params.get('default-dst')          || '');
    fetchLogoByLocation();
  }, []);

  useEffect(() => {
    fetchLogoByLocation();
  }, []); // Empty dependency array means this runs once on component mount

  const handleMethodChange = (event) => {
    setMethod(event.target.value);
    setError({
      firstName: false,
      lastName: false,
      phone: false,
      idNumber: false,
      birthYear: false,
      whatsapp: false,
      countryCode: false,
      pinCode: false,
      username: false,
    });
    setFormData(prev => ({
      ...prev,
      phone: '',
      idNumber: '',
      birthYear: '',
      whatsapp: '',
      countryCode: '',
      pinCode: '',
      username: '',
    }));
    setShowPinInput(false);
    setServerMessage('');
  };

  const handleInputChange = (field) => (event) => {
    let value = event.target.value;
    
    // TC Kimlik için sadece rakam girişine izin ver
    if (field === 'idNumber') {
      value = value.replace(/[^0-9]/g, '').slice(0, 11);
    }
    
    // Doğum yılı için sadece rakam ve 4 karakter
    if (field === 'birthYear') {
      value = value.replace(/[^0-9]/g, '').slice(0, 4);
    }
    // For PIN code, allow only numbers and limit length (e.g., 6 digits)
    if (field === 'pinCode') {
      value = value.replace(/[^0-9]/g, '').slice(0, 6);
    }
    // For country code, allow '+' and numbers, limit length (e.g., 4 chars like +90)
    if (field === 'countryCode') {
        value = value.replace(/[^0-9+]/g, '').slice(0, 4);
    }
    // For phone number, prevent leading zeros and allow only numbers
    if (field === 'username' && isPhoneLogin) {
      value = value.replace(/[^0-9]/g, '');
      // Remove leading zeros
      value = value.replace(/^0+/, '');
      // Limit to 10 digits (standard phone number length without country code)
      value = value.slice(0, 10);
    }

    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    setError(prev => ({
      ...prev,
      [field]: false
    }));
  };
   // 🔑 detect iframe loads and, when it ends up on the dst page, nav the top window
   const handleIframeLoad = () => {
     const iframe = iframeRef.current;
     if (!iframe) return;
     try {
       // if we can read href, it's same-origin—skip login page itself
       const href = iframe.contentWindow.location.href;
       if (
         href &&
         href !== 'about:blank' &&
         !href.includes(new URL(linkLoginOnly).hostname)
       ) {
         window.location.href = href;
       }
     } catch (err) {
       // cross-origin → must be the external dst
       window.location.href = linkOrig || defaultDst;
     }
   };

  const submitHotspotLogin = (username, password) => {
    console.log('linkLoginOnly:', linkLoginOnly, 'username:', username, 'linkOrig:', linkOrig, 'defaultDst:', defaultDst);
    if (!linkLoginOnly) {
      setServerMessage('Hotspot login URL missing – please retry.');
      return;
    }

    // Parse the login URL to get the base URL and dst parameter
    const loginUrl = new URL(linkLoginOnly);
    let dst = loginUrl.searchParams.get('dst');
    
    // If dst is empty or just whitespace, use defaultDst
    if (!dst || dst.trim() === '') {
      dst = defaultDst;
    }
    
    // If still no dst, use linkOrig
    if (!dst) {
      dst = linkOrig;
    }

    // If still no dst, use a default fallback
    if (!dst) {
      dst = 'http://captive.apple.com/hotspot-detect.html';
    }

    // create & submit a hidden form to RouterOS
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = loginUrl.origin + loginUrl.pathname;  // Use the base URL without parameters
    form.target = 'hotspotLoginFrame';  // see iframe we'll add below

    const fields = [
      ['username', username],
      ['password', password],
      ['dst', dst],
      ['popup', 'true'],
    ];

    console.log('Submitting form with:', {
      action: form.action,
      username,
      dst,
      popup: 'true'
    });

    fields.forEach(([name, val]) => {
      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = name;
      inp.value = val;
      form.appendChild(inp);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };


  const handlePinSubmit = async () => {
    setServerMessage('');
    setIsLoading(true);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://apiproxy.logispot.net';
    const secureApiBaseUrl = apiBaseUrl.replace(/^http:/, 'https:');

    const newError = {
      pinCode: !formData.pinCode || formData.pinCode.length < 4,
    };
    setError(prev => ({ ...prev, ...newError }));

    if (!newError.pinCode) {
      try {
        const payload = new FormData();
        payload.append('country_code', formData.countryCode.slice(1));
        payload.append('phone_number', formData.phone);
        payload.append('pin_code', formData.pinCode);

        const response = await fetch(`${secureApiBaseUrl}/api/validate-sms-code`, {
          method: 'POST',
          body: payload,
        });
        const data = await response.json();

        if (data.success) {
          setServerMessage(data.message || t.messages?.pinVerifiedSuccess || 'Verification successful!');
          
          // Register user after successful verification
          if (verificationData) {
            try {
              // Create JSON payload for registration - only username and password as per API
              const registerPayload = {
                username: verificationData.type === 'sms' 
                  ? `${formData.countryCode}${formData.phone}`
                  : formData.idNumber,
                password: formData.pinCode
              };

              const registerResponse = await fetch(`${secureApiBaseUrl}/api/register`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(registerPayload),
              });

              const registerData = await registerResponse.json();

              if (registerData.success) {
                setServerMessage(registerData.message || t.messages?.registrationSuccess || 'Registration successful!');
                // Redirect to the URL provided by the server
                if (registerData.redirectUrl) {
                  window.location.href = registerData.redirectUrl;
                }
              } else {
                setServerMessage(registerData.message || t.errors?.registrationFailed || 'Registration failed. Please try again.');
              }
            } catch (err) {
              console.error('Error registering user:', err);
              setServerMessage(t.errors?.registrationError || 'Error during registration. Please try again.');
            }
          }
        } else {
          setServerMessage(data.message || t.errors?.invalidPin || 'Invalid verification code. Please try again.');
          setError(prev => ({ ...prev, pinCode: true }));
        }
      } catch (err) {
        console.error('Error validating code:', err);
        setServerMessage(t.errors?.networkError || 'Network error. Please try again.');
      }
    }
    setIsLoading(false);
  };

  const handleSubmit = async () => {
    setServerMessage('');
    setIsLoading(true);

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://apiproxy.logispot.net';
    const secureApiBaseUrl = apiBaseUrl.replace(/^http:/, 'https:');

    if (method === 'sms') {
      const newError = {
        firstName: !formData.firstName,
        lastName: !formData.lastName,
        countryCode: !formData.countryCode,
        phone: !formData.phone,
      };
      setError(prev => ({ ...prev, ...newError }));

      if (!newError.firstName && !newError.lastName && !newError.countryCode && !newError.phone) {
        try {
          const payload = new FormData();
          payload.append('country_code', formData.countryCode.slice(1));
          payload.append('phone_number', formData.phone);

          const response = await fetch(`${secureApiBaseUrl}/api/verify-sms`, {
            method: 'POST',
            body: payload,
          });
          const data = await response.json();

          if (data.success) {
            setServerMessage(data.message || t.messages?.pinSentSuccess || 'Verification code sent successfully!');
            setShowPinInput(true);
            setVerificationData({
              type: 'sms',
              username: `${formData.countryCode.replace('+', '')}${formData.phone}`
            });
          } else {
            setServerMessage(data.message || t.errors?.pinSentFailed || 'Failed to send verification code. Please try again.');
            setError(prev => ({ ...prev, phone: true, countryCode: true }));
          }
        } catch (err) {
          console.error('Error sending verification code:', err);
          setServerMessage(t.errors?.networkError || 'Network error. Please try again.');
        }
      }
    } else if (method === 'tc') {
      const newError = {
        firstName: !formData.firstName,
        lastName: !formData.lastName,
        idNumber: !formData.idNumber || formData.idNumber.length !== 11,
        birthYear: !formData.birthYear || formData.birthYear.length !== 4
      };
      setError(prev => ({ ...prev, ...newError }));
      
      if (!newError.firstName && !newError.lastName && !newError.idNumber && !newError.birthYear) {
        try {
          const payload = new FormData();
          payload.append('tckn', formData.idNumber);
          payload.append('name', formData.firstName);
          payload.append('surname', formData.lastName);
          payload.append('dob', formData.birthYear);

          const response = await fetch(`${secureApiBaseUrl}/api/verify-tckn`, {
            method: 'POST',
            body: payload,
          });
          const data = await response.json();

          if (data.success) {
            setServerMessage(data.message || t.messages?.tcknVerificationSuccess || 'TCKN verified successfully!');
            // Register user after successful TCKN verification
            try {
              const registerPayload = {
                username: formData.idNumber,
                password: data.pin_code
              };

              const registerResponse = await fetch(`${secureApiBaseUrl}/api/register`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(registerPayload),
              });

              const registerData = await registerResponse.json();

              if (registerData.success) {
                setServerMessage(registerData.message || t.messages?.registrationSuccess || 'Registration successful!');
                // Redirect to the URL provided by the server
                if (registerData.redirectUrl) {
                  window.location.href = registerData.redirectUrl;
                }
              } else {
                setServerMessage(registerData.message || t.errors?.registrationFailed || 'Registration failed. Please try again.');
              }
            } catch (err) {
              console.error('Error registering user:', err);
              setServerMessage(t.errors?.registrationError || 'Error during registration. Please try again.');
            }
          } else {
            setServerMessage(data.message || t.messages?.tcknVerificationFailed || 'TCKN verification failed. Please check details.');
            setError(prev => ({
              ...prev,
              firstName: true,
              lastName: true,
              idNumber: true,
              birthYear: true,
            }));
          }
        } catch (err) {
          console.error('Error verifying TCKN:', err);
          setServerMessage(t.errors?.networkError || 'Network error. Please try again.');
        }
      }
    } else if (method === 'login') {
      const newError = {
        username: !formData.username,
        password: !formData.password,
        countryCode: isPhoneLogin && !formData.countryCode,
      };
      setError(prev => ({ ...prev, ...newError }));

      if (!newError.username && !newError.password && !newError.countryCode) {
        try {
          const username = isPhoneLogin 
            ? `${formData.countryCode.replace('+', '')}${formData.username}`
            : formData.username;

          const loginPayload = {
            username: username,
            password: formData.password
          };

          const loginResponse = await fetch(`${secureApiBaseUrl}/api/login`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(loginPayload),
          });

          const loginData = await loginResponse.json();

          if (loginData.success) {
            setServerMessage(loginData.message || t.messages?.loginSuccess || 'Login successful!');
            // Redirect to the URL provided by the server
            if (loginData.redirectUrl) {
              window.location.href = loginData.redirectUrl;
            }
          } else {
            setServerMessage(loginData.message || t.errors?.loginFailed || 'Login failed. Please try again.');
          }
        } catch (err) {
          console.error('Error during login:', err);
          setServerMessage(t.errors?.networkError || 'Network error. Please try again.');
        }
      }
    }
    setIsLoading(false);
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  const renderInputFields = () => {
    if (method === 'sms') {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            fullWidth
            value={formData.firstName}
            onChange={handleInputChange('firstName')}
            error={error.firstName}
            helperText={error.firstName ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.sms?.firstName?.label || 'First Name'}
            placeholder={t.methods?.sms?.firstName?.placeholder || 'Enter first name'}
            variant="outlined"
            sx={inputStyles}
            disabled={isLoading || showPinInput}
          />
          <TextField
            fullWidth
            value={formData.lastName}
            onChange={handleInputChange('lastName')}
            error={error.lastName}
            helperText={error.lastName ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.sms?.lastName?.label || 'Last Name'}
            placeholder={t.methods?.sms?.lastName?.placeholder || 'Enter last name'}
            variant="outlined"
            sx={inputStyles}
            disabled={isLoading || showPinInput}
          />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <FormControl variant="outlined" sx={{ minWidth: 120, flexShrink: 0 }} disabled={isLoading || showPinInput} error={error.countryCode}>
              <InputLabel id="country-code-label">
                {t.methods?.sms?.countryCode?.label || 'Country Code'}
              </InputLabel>
              <Select
                labelId="country-code-label"
                id="country-code-select"
                value={formData.countryCode}
                onChange={handleInputChange('countryCode')}
                label={t.methods?.sms?.countryCode?.label || 'Country Code'}
              >
                {countryCodes.map((option) => (
                  <MenuItem key={option.code} value={option.code}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              value={formData.phone}
              onChange={handleInputChange('phone')}
              error={error.phone}
              helperText={error.phone ? (t.errors?.required || 'Required') : ''}
              label={t.methods?.sms?.phoneNumber?.label || 'Phone Number'}
              placeholder={t.methods?.sms?.phoneNumber?.placeholder || 'e.g., 5051234567'}
              variant="outlined"
              sx={inputStyles}
              disabled={isLoading || showPinInput}
            />
          </Box>
        </Box>
      );
    }
    
    if (method === 'tc') {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            fullWidth
            value={formData.firstName}
            onChange={handleInputChange('firstName')}
            error={error.firstName}
            helperText={error.firstName ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.tc?.firstName?.label || 'First Name'}
            placeholder={t.methods?.tc?.firstName?.placeholder || 'Enter first name'}
            variant="outlined"
            sx={inputStyles}
            disabled={isLoading}
          />
          <TextField
            fullWidth
            value={formData.lastName}
            onChange={handleInputChange('lastName')}
            error={error.lastName}
            helperText={error.lastName ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.tc?.lastName?.label || 'Last Name'}
            placeholder={t.methods?.tc?.lastName?.placeholder || 'Enter last name'}
            variant="outlined"
            sx={inputStyles}
            disabled={isLoading}
          />
          <TextField
            fullWidth
            value={formData.idNumber}
            onChange={handleInputChange('idNumber')}
            error={error.idNumber}
            helperText={error.idNumber ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.tc?.idNumber?.label || 'ID Number'}
            placeholder={t.methods?.tc?.idNumber?.placeholder || 'Enter ID number'}
            variant="outlined"
            sx={inputStyles}
            disabled={isLoading}
          />
          <TextField
            fullWidth
            value={formData.birthYear}
            onChange={handleInputChange('birthYear')}
            error={error.birthYear}
            helperText={error.birthYear ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.tc?.birthYear?.label || 'Birth Year'}
            placeholder={t.methods?.tc?.birthYear?.placeholder || 'Enter birth year'}
            variant="outlined"
            sx={inputStyles}
            type="number"
            disabled={isLoading}
          />
        </Box>
      );
    }

    if (method === 'login') {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 1,
            mb: 1,
            p: 1,
            borderRadius: 1,
            bgcolor: 'grey.50'
          }}>
            <FormControlLabel
              control={
                <Switch
                  checked={isPhoneLogin}
                  onChange={(e) => setIsPhoneLogin(e.target.checked)}
                  color="primary"
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {isPhoneLogin ? <PhoneIcon color="primary" /> : <PersonIcon />}
                  <Typography>
                    {isPhoneLogin ? 'Login with Phone Number' : 'Login with Username'}
                  </Typography>
                </Box>
              }
            />
          </Box>

          {isPhoneLogin ? (
            <Box sx={{ display: 'flex', gap: 2 }}>
              <FormControl variant="outlined" sx={{ minWidth: 120, flexShrink: 0 }} error={error.countryCode}>
                <InputLabel id="login-country-code-label">
                  {t.methods?.sms?.countryCode?.label || 'Country Code'}
                </InputLabel>
                <Select
                  labelId="login-country-code-label"
                  id="login-country-code-select"
                  value={formData.countryCode}
                  onChange={handleInputChange('countryCode')}
                  label={t.methods?.sms?.countryCode?.label || 'Country Code'}
                >
                  {countryCodes.map((option) => (
                    <MenuItem key={option.code} value={option.code}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth
                value={formData.username}
                onChange={handleInputChange('username')}
                error={error.username}
                helperText={error.username ? (t.errors?.required || 'Required') : ''}
                label={t.methods?.login?.username?.label || 'Phone Number'}
                placeholder="5051234567"
                variant="outlined"
                sx={inputStyles}
                disabled={isLoading}
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[1-9][0-9]*',
                  title: 'Enter phone number without leading zeros (max 10 digits)',
                  maxLength: 10
                }}
              />
            </Box>
          ) : (
            <TextField
              fullWidth
              value={formData.username}
              onChange={handleInputChange('username')}
              error={error.username}
              helperText={error.username ? (t.errors?.required || 'Required') : ''}
              label={t.methods?.login?.username?.label || 'Username'}
              placeholder={t.methods?.login?.username?.placeholder || 'Enter username (TC, passport, room number, etc.)'}
              variant="outlined"
              sx={inputStyles}
              disabled={isLoading}
            />
          )}
          <TextField
            fullWidth
            value={formData.password}
            onChange={handleInputChange('password')}
            error={error.password}
            helperText={error.password ? (t.errors?.required || 'Required') : ''}
            label={t.methods?.login?.password?.label || 'Password'}
            placeholder={t.methods?.login?.password?.placeholder || 'Enter password'}
            variant="outlined"
            type="password"
            sx={inputStyles}
            disabled={isLoading}
          />
        </Box>
      );
    }

    return <Box />;
  };

  const inputStyles = {
    '& .MuiOutlinedInput-root': {
      borderRadius: 2,
      backgroundColor: '#ffffff',
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: '0 6px 16px rgba(0,0,0,0.1)',
        transform: 'translateY(-2px)',
      },
      '&.Mui-focused': {
        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
        transform: 'translateY(-2px)',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: 2,
    },
  };

  const PasswordRequirement = ({ met, text }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
      {met ? (
        <CheckCircleIcon color="success" fontSize="small" />
      ) : (
        <ErrorIcon color="error" fontSize="small" />
      )}
      <Typography variant="body2" color={met ? 'success.main' : 'error.main'}>
        {text}
      </Typography>
    </Box>
  );

  return (
    <>
    <iframe
         name="hotspotLoginFrame"
         ref={iframeRef}
         style={{ display: 'none' }}
         onLoad={handleIframeLoad}
    />
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Card 
        elevation={8}
        sx={{
          borderRadius: 4,
          overflow: 'hidden',
          background: 'linear-gradient(to bottom, rgba(255,255,255,0.98), rgba(255,255,255,0.95))',
          backdropFilter: 'blur(10px)',
          border: '1px solid',
          borderColor: 'grey.100',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
          transform: 'perspective(1000px) rotateX(2deg)',
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'perspective(1000px) rotateX(0deg)',
            boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
          }
        }}
      >
        {/* Dil Seçimi */}
        <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 2 }}>
          <ToggleButton
            value="language"
            selected={language === 'en'}
            onChange={toggleLanguage}
            sx={{
              border: '2px solid',
              borderColor: 'grey.300',
              borderRadius: '20px',
              px: 2,
              py: 0.5,
              backgroundColor: 'rgba(255,255,255,0.9)',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,1)',
                borderColor: '#1976d2',
                transform: 'translateY(-2px)',
                boxShadow: '0 6px 16px rgba(0,0,0,0.15)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <TranslateIcon fontSize="small" />
              <Typography variant="button">
                {t.buttons.language}
              </Typography>
            </Box>
          </ToggleButton>
        </Box>

        {/* Logo */}
        <Box sx={{ 
          p: 2, 
          display: 'flex', 
          justifyContent: 'center',
          alignItems: 'center',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          width: '100%'
        }}>
          <Box
            component="img"
            src={logoUrl}
            alt="Sojubar Logo"
            sx={{
              width: '100%',
              maxWidth: '800px',
              height: 'auto',
              objectFit: 'contain',
              filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'scale(1.02)',
                filter: 'drop-shadow(0 6px 12px rgba(0,0,0,0.15))',
              }
            }}
          />
        </Box>

        <CardContent sx={{ p: { xs: 3, sm: 5 } }}>
          {/* Sosyal Medya */}
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 5 }}>
            <IconButton
              size="medium"
              color="primary"
              href={socialLinks.instagram}
              target="_blank"
              sx={{ 
                backgroundColor: 'grey.50',
                border: '1.5px solid',
                borderColor: 'grey.200',
                '&:hover': { 
                  backgroundColor: 'grey.100',
                  borderColor: 'secondary.main',
                }
              }}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              size="medium"
              color="primary"
              href={socialLinks.facebook}
              target="_blank"
              sx={{ 
                backgroundColor: 'grey.50',
                border: '1.5px solid',
                borderColor: 'grey.200',
                '&:hover': { 
                  backgroundColor: 'grey.100',
                  borderColor: 'secondary.main',
                }
              }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              size="medium"
              color="primary"
              href={socialLinks.twitter}
              target="_blank"
              sx={{ 
                backgroundColor: 'grey.50',
                border: '1.5px solid',
                borderColor: 'grey.200',
                '&:hover': { 
                  backgroundColor: 'grey.100',
                  borderColor: 'secondary.main',
                }
              }}
            >
              <TwitterIcon />
            </IconButton>
          </Box>

          {/* Doğrulama Yöntemi Seçimi */}
          <FormControl component="fieldset" sx={{ width: '100%', mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: 'text.primary', textAlign: 'center' }}>
              {t.verificationTitle}
            </Typography>
            <RadioGroup
              row
              value={method}
              onChange={handleMethodChange}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                gap: 2,
                width: '100%',
                mb: 3
              }}
            >
              {verificationMethods.map(({ key, icon }) => (
                <FormControlLabel
                  key={key}
                  value={key}
                  control={
                    <Radio
                      sx={{
                        display: 'none',
                      }}
                    />
                  }
                  label={
                    <Box
                      sx={{
                        position: 'relative',
                        width: { xs: '100px', sm: '130px' },
                        height: { xs: '100px', sm: '130px' },
                        borderRadius: '50%',
                        backgroundColor: method === key ? '#1976d2' : '#f5f5f5',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        boxShadow: method === key 
                          ? '0 4px 20px rgba(25, 118, 210, 0.3)'
                          : '0 2px 10px rgba(0,0,0,0.1)',
                        '&:hover': {
                          transform: 'translateY(-5px)',
                          boxShadow: method === key 
                            ? '0 6px 25px rgba(25, 118, 210, 0.4)'
                            : '0 4px 15px rgba(0,0,0,0.15)',
                        },
                        '&::before': {
                          content: '""',
                          position: 'absolute',
                          top: -2,
                          left: -2,
                          right: -2,
                          bottom: -2,
                          borderRadius: '50%',
                          border: '2px solid',
                          borderColor: method === key ? '#1976d2' : 'transparent',
                          transition: 'all 0.3s ease'
                        }
                      }}
                    >
                      <Box sx={{ 
                        color: method === key ? '#fff' : '#666',
                        transform: 'scale(1.5)',
                        mb: 1,
                        transition: 'all 0.3s ease'
                      }}>
                        {icon}
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{
                          color: method === key ? '#fff' : '#666',
                          fontWeight: 500,
                          textAlign: 'center',
                          fontSize: { xs: '0.8rem', sm: '0.9rem' },
                          px: 1,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        {t.methods[key].label}
                      </Typography>
                    </Box>
                  }
                  sx={{
                    m: 0,
                    flex: '0 0 auto'
                  }}
                />
              ))}
            </RadioGroup>
          </FormControl>

          {/* Giriş Alanı */}
          <Box sx={{ mb: 4 }}>
            {renderInputFields()}
          </Box>

          {/* Server Message Display */}
          {serverMessage && (
            <Typography 
              color={serverMessage.toLowerCase().includes('failed') || serverMessage.toLowerCase().includes('error') || serverMessage.toLowerCase().includes('invalid') ? "error" : "success.main"}
              sx={{ mb: 2, textAlign: 'center', fontWeight: 500 }}
            >
              {serverMessage}
            </Typography>
          )}

          {/* Giriş Butonu */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleSubmit}
            disabled={isLoading || (method === 'sms' && showPinInput)}
            sx={{
              py: 1.5,
              borderRadius: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              textTransform: 'none',
              background: 'linear-gradient(45deg, #1565c0 0%, #1976d2 100%)',
              boxShadow: '0 4px 16px rgba(25, 118, 210, 0.3)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 24px rgba(25, 118, 210, 0.4)',
              },
              '&:active': {
                transform: 'translateY(0)',
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
              },
            }}
          >
            {isLoading 
              ? (t.buttons?.loading || 'Loading...') 
              : method === 'sms' 
                ? (t.buttons?.sendPin || 'Send PIN')
                : (t.buttons?.submit || 'Submit')
            }
          </Button>

          {/* PIN Code Modal */}
          <Modal
            aria-labelledby="pin-code-modal-title"
            aria-describedby="pin-code-modal-description"
            open={showPinInput && (method === 'sms' || method === 'tc')}
            onClose={() => setShowPinInput(false)}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
              backdrop: {
                timeout: 500,
                sx: { backdropFilter: 'blur(3px)' }
              },
            }}
          >
            <Fade in={showPinInput && (method === 'sms' || method === 'tc')}>
              <Box sx={modalStyle}>
                <Typography id="pin-code-modal-title" variant="h6" component="h2" sx={{ mb: 2, textAlign: 'center' }}>
                  {t.methods?.sms?.pinCodeModalTitle || 'Enter Verification Code'}
                </Typography>
                <TextField
                  fullWidth
                  value={formData.pinCode}
                  onChange={handleInputChange('pinCode')}
                  error={error.pinCode}
                  helperText={error.pinCode ? (t.errors?.invalidPinInput || 'Invalid code') : ''}
                  label={t.methods?.sms?.pinCode?.label || 'Verification Code'}
                  placeholder={t.methods?.sms?.pinCode?.placeholder || 'Enter verification code'}
                  variant="outlined"
                  sx={{ ...inputStyles, mb: 2 }}
                  disabled={isLoading}
                  type="tel"
                  inputProps={{ maxLength: 6, autoFocus: true }}
                />
                {serverMessage && (showPinInput && (method === 'sms' || method === 'tc')) && (
                  <Typography 
                    color={serverMessage.toLowerCase().includes('failed') || serverMessage.toLowerCase().includes('error') || serverMessage.toLowerCase().includes('invalid') ? "error" : "success.main"}
                    sx={{ mb: 2, textAlign: 'center', fontSize: '0.9rem' }}
                  >
                    {serverMessage}
                  </Typography>
                )}
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handlePinSubmit}
                  disabled={isLoading}
                  sx={{ 
                    py: 1.5, 
                    fontSize: '1rem', 
                    textTransform: 'none',
                  }}
                >
                  {isLoading ? (t.buttons?.loading || 'Loading...') : (t.buttons?.verifyPin || 'Verify Code')}
                </Button>
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() => {
                    setShowPinInput(false);
                    setServerMessage('');
                    setError(prev => ({...prev, pinCode: false}));
                  }}
                  disabled={isLoading}
                  sx={{ mt: 1, py: 1.5, fontSize: '1rem', textTransform: 'none' }}
                >
                  {t.buttons?.cancel || 'Cancel'}
                </Button>
              </Box>
            </Fade>
          </Modal>

          {/* İşletme Bilgileri */}
          <Box sx={{ mt: 6 }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper
                  elevation={4}
                  sx={{
                    p: 3,
                    height: '100%',
                    borderRadius: 3,
                    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    transform: 'perspective(1000px) rotateY(2deg)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'perspective(1000px) rotateY(0deg) translateY(-4px)',
                      boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
                    },
                  }}
                >
                  <Typography 
                    variant="h6" 
                    gutterBottom 
                    sx={{ 
                      fontWeight: 600, 
                      color: '#1976d2',
                      textAlign: 'center',
                      width: '100%',
                      mb: 3
                    }}
                  >
                    {t.socialMedia.follow}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 2 }}>
                    <IconButton
                      href={socialLinks.instagram}
                      target="_blank"
                      sx={{
                        color: '#E4405F',
                        backgroundColor: 'rgba(228, 64, 95, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(228, 64, 95, 0.2)',
                          transform: 'translateY(-4px)',
                          boxShadow: '0 4px 12px rgba(228, 64, 95, 0.3)',
                        },
                      }}
                    >
                      <InstagramIcon />
                    </IconButton>
                    <IconButton
                      href={socialLinks.facebook}
                      target="_blank"
                      sx={{
                        color: '#1877F2',
                        backgroundColor: 'rgba(24, 119, 242, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(24, 119, 242, 0.2)',
                          transform: 'translateY(-4px)',
                          boxShadow: '0 4px 12px rgba(24, 119, 242, 0.3)',
                        },
                      }}
                    >
                      <FacebookIcon />
                    </IconButton>
                    <IconButton
                      href={socialLinks.twitter}
                      target="_blank"
                      sx={{
                        color: '#1DA1F2',
                        backgroundColor: 'rgba(29, 161, 242, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          backgroundColor: 'rgba(29, 161, 242, 0.2)',
                          transform: 'translateY(-4px)',
                          boxShadow: '0 4px 12px rgba(29, 161, 242, 0.3)',
                        },
                      }}
                    >
                      <TwitterIcon />
                    </IconButton>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Box>

          {/* Powered by LogiSafe */}
          <Box 
            sx={{ 
              mt: 4, 
              mb: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography
              component="a"
              href="https://logisafe.net/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                opacity: 0.8,
                transition: 'all 0.3s ease',
                '&:hover': {
                  opacity: 1,
                  color: '#1976d2',
                  transform: 'translateY(-1px)'
                }
              }}
            >
              Powered by LogiSafe
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
    </>
  );
};

export default HotspotRegister; 